import { Controller } from "@hotwired/stimulus"
import get from "lodash.get"

// Connects to data-controller="toggle-active"
export default class extends Controller {
  static targets = ["output"]
  static values = {
    event: String,
  }

  connect() {
    this.setActive(get(this.element, "dataset.active") === "true")
  }

  toggle() {
    this.setActive(!this.active)
  }

  off() {
    this.setActive(false)
  }

  on() {
    this.setActive(true)
  }

  setActive(active) {
    this.active = active
    this.updateOutputs()

    if (this.hasEventValue) {
      this.dispatch(this.eventValue, { detail: { active: this.active } })
    }
  }

  updateOutputs() {
    this.outputTargets.forEach(element => {
      this.updateClasses(
        element,
        get(element, "dataset.classesActive"),
        this.active
      )
      this.updateClasses(
        element,
        get(element, "dataset.classesInactive"),
        !this.active
      )
    })
  }

  updateClasses(element, classes, value) {
    if (!classes || !element) {
      return
    }

    element.classList.toggle(classes, value)
  }
}
